import { createContext, useContext, useEffect, useState } from "react";
import { me as apiMe, login as apiLogin } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("ep_token");
        if (!token) {
            setLoading(false);
            return;
        }
        apiMe()
            .then((u) => setUser(u))
            .catch(() => {
                localStorage.removeItem("ep_token");
                localStorage.removeItem("ep_user");
            })
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const res = await apiLogin(email, password);
        localStorage.setItem("ep_token", res.access_token);
        localStorage.setItem("ep_user", JSON.stringify(res.user));
        setUser(res.user);
        return res.user;
    };

    const logout = () => {
        localStorage.removeItem("ep_token");
        localStorage.removeItem("ep_user");
        setUser(null);
    };

    return (
        <AuthCtx.Provider value={{ user, loading, login, logout }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
